import { BriefcaseIcon } from "@heroicons/react/solid";
import React from "react";
import { experiences } from "../../data";
import MainIntersectProvider from "../../MainIntersectProvider";
import Experience from "./Experience/Experience";

function Experiences() {
	return (
		<section id='experiences'>
			<div className='container px-10 xl:px-40 pt-20 mx-auto'>
				<div className='text-center mb-20'>
					<MainIntersectProvider>
						<BriefcaseIcon className='w-10 inline-block mb-4' />
					</MainIntersectProvider>
					<h1 className='sm:text-3xl text-2xl font-medium title-font text-white mb-4'>
						Work Experiences
					</h1>
					<p className='text-base leading-relaxed xl:w-2/4 lg:w-3/4 mx-auto'>
						A couple of experiences
					</p>
				</div>
				<ol className='relative border-l border-gray-200'>
					{[...experiences].map((experience, index) => (
						<Experience
							key={experience + "__" + index}
							experience={experience}
						/>
					))}
				</ol>
			</div>
		</section>
	);
}

export default Experiences;
